import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { ViewsComponent } from './views.component';
import { AdminGuardService } from '../auth/admin-guard.service';
import { AgentGuardService } from '../auth/agent-guard.service';
import { CitizenGuardService } from '../auth/citizen-guard.service';

const routes: Routes = [{
  path: '',
  component: ViewsComponent,
  children: [
    {
      path: 'settings',
      //canActivate: [AdminGuardService],
      loadChildren: () => import('../views/settings/settings.module')
        .then(m => m.SettingsModule),
    },
    {
      path: 'requests',
      //canActivate: [AgentGuardService, CitizenGuardService],
      loadChildren: () => import('../views/request/request.module')
        .then(m => m.RequestModule),
    },
    {
      path: 'report',
      //canActivate: [AgentGuardService, CitizenGuardService],
      loadChildren: () => import('../views/report/report.module')
        .then(m => m.ReportModule), 
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewsRoutingModule {
}
